{
  "adobeExperienceCloudNoOrgsSelect": "Anderes Unternehmenskonto auswählen",
  "adobeExperienceCloudSelectedOrg": "Ausgewählte Organisation: {org}",
  "appSwitcherLinkOutIconLabel": "Wird in einem neuen Fenster geöffnet",
  "feedback button default": "Wie bewerten Sie uns? Geben Sie hier Feedback.",
  "help": "Hilfe",
  "launchsidebar": "Seitenleiste starten",
  "more actions": "Weitere Aktionen",
  "searchButton": "Suchen",
  "solutionSwitcher": "Zu anderer Lösung wechseln",
  "solutionSwitcherList": "Liste der Programme",
  "solutionSwitcherPopover": "Popover zur Liste der Programme"
}
